// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.clip {
  display: flex;
  position: relative;
}
.clip_img {
  position: absolute;
  background-repeat: no-repeat;
  background-position: 70% 20%;
  background-size: cover;
  transform-origin: center;
  width: 100%;
  height: 100vh;
  top: 0;
  animation: StretchFull 0.8s 7s ease-in-out forwards;
  transition: all 5s ease-in-out;
  z-index: 1;
}

img {
  width: 100%;
  height: 100%;
}

#clip1 {
  animation: clip1 2s linear forwards;
}

#clipa {
  transform: scale(1.1, 1.1);
  animation: clipa 7s linear forwards;
}

#clip2 {
  transform: scale(1.12, 1.12);
  animation: clip2 3s linear forwards;
}

#clipb {
  transform: scale(1.14, 1.14);
  animation: clipb 2s linear forwards;
}

#clip3 {
  transform: scale(1.15, 1.15);
  animation: clip3 5s linear forwards;
}

#clip4 {
  transform: scale(1.13, 1.13);
  animation: clip4 4s linear forwards;
}

/** KeyFrames  **/
@keyframes clip1 {
  0% {
    clip-path: polygon(0% -50%, 50% -50%, -50% 50%, -100% 50%);
  }
  100% {
    clip-path: polygon(150% 50%, 200% 50%, 100% 150%, 50% 150%);
  }
}
@keyframes clipa {
  0% {
    clip-path: polygon(-5% -55%, 55% -45%, -45% 55%, -95% 55%);
  }
  100% {
    clip-path: polygon(150% 50%, 200% 50%, 100% 150%, 50% 150%);
  }
}
@keyframes clip2 {
  0% {
    clip-path: polygon(50% -50%, 100% -50%, 200% 50%, 150% 50%);
  }
  100% {
    clip-path: polygon(-100% 50%, -50% 50%, 50% 150%, 0% 150%);
  }
}
@keyframes clipb {
  0% {
    clip-path: polygon(40% -60%, 100% -50%, 190% 40%, 150% 50%);
  }
  100% {
    clip-path: polygon(-100% 50%, -50% 50%, 50% 150%, 0% 150%);
  }
}
@keyframes clip3 {
  0% {
    clip-path: polygon(-100% -150%, -50% -150%, -150% -50%, -200% -50%);
  }
  100% {
    clip-path: polygon(150% 50%, 200% 50%, 100% 150%, 50% 150%);
  }
}
@keyframes clip4 {
  0% {
    clip-path: polygon(150% -150%, 200% -150%, 300% -50%, 250% -50%);
  }
  100% {
    clip-path: polygon(-100% 50%, -50% 50%, 50% 150%, 0% 150%);
  }
}
@keyframes StretchFull {
  0% {
    height: 100vh;
  }
  100% {
    height: 500px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Clip/Clip.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,kBAAA;AACF;AACE;EACE,kBAAA;EAEA,4BAAA;EACA,4BAAA;EACA,sBAAA;EACA,wBAAA;EACA,WAAA;EACA,aAAA;EACA,MAAA;EACA,mDAAA;EACA,8BAAA;EACA,UAAA;AAAJ;;AAIA;EACE,WAAA;EACA,YAAA;AADF;;AAIA;EACE,mCAAA;AADF;;AAGA;EACE,0BAAA;EACA,mCAAA;AAAF;;AAEA;EACE,4BAAA;EACA,mCAAA;AACF;;AACA;EACE,4BAAA;EACA,mCAAA;AAEF;;AAAA;EACE,4BAAA;EACA,mCAAA;AAGF;;AADA;EACE,4BAAA;EACA,mCAAA;AAIF;;AADA,iBAAA;AAEA;EACE;IACE,0DAAA;EAGF;EADA;IACE,2DAAA;EAGF;AACF;AADA;EACE;IACE,0DAAA;EAGF;EADA;IACE,2DAAA;EAGF;AACF;AADA;EACE;IACE,2DAAA;EAGF;EADA;IACE,0DAAA;EAGF;AACF;AADA;EACE;IACE,2DAAA;EAGF;EADA;IACE,0DAAA;EAGF;AACF;AADA;EACE;IACE,mEAAA;EAGF;EADA;IACE,2DAAA;EAGF;AACF;AADA;EACE;IACE,gEAAA;EAGF;EADA;IACE,0DAAA;EAGF;AACF;AAAA;EACE;IACE,aAAA;EAEF;EAAA;IACE,aAAA;EAEF;AACF","sourcesContent":[".clip {\n  display: flex;\n  position: relative;\n\n  &_img {\n    position: absolute;\n\n    background-repeat: no-repeat;\n    background-position: 70% 20%;\n    background-size: cover;\n    transform-origin: center;\n    width: 100%;\n    height: 100vh;\n    top: 0;\n    animation: StretchFull 0.8s 7s ease-in-out forwards;\n    transition: all 5s ease-in-out;\n    z-index: 1;\n  }\n}\n\nimg {\n  width: 100%;\n  height: 100%;\n}\n\n#clip1 {\n  animation: clip1 2s linear forwards;\n}\n#clipa {\n  transform: scale(1.1, 1.1);\n  animation: clipa 7s linear forwards;\n}\n#clip2 {\n  transform: scale(1.12, 1.12);\n  animation: clip2 3s linear forwards;\n}\n#clipb {\n  transform: scale(1.14, 1.14);\n  animation: clipb 2s linear forwards;\n}\n#clip3 {\n  transform: scale(1.15, 1.15);\n  animation: clip3 5s linear forwards;\n}\n#clip4 {\n  transform: scale(1.13, 1.13);\n  animation: clip4 4s linear forwards;\n}\n\n/** KeyFrames  **/\n\n@keyframes clip1 {\n  0% {\n    clip-path: polygon(0% -50%, 50% -50%, -50% 50%, -100% 50%);\n  }\n  100% {\n    clip-path: polygon(150% 50%, 200% 50%, 100% 150%, 50% 150%);\n  }\n}\n@keyframes clipa {\n  0% {\n    clip-path: polygon(-5% -55%, 55% -45%, -45% 55%, -95% 55%);\n  }\n  100% {\n    clip-path: polygon(150% 50%, 200% 50%, 100% 150%, 50% 150%);\n  }\n}\n@keyframes clip2 {\n  0% {\n    clip-path: polygon(50% -50%, 100% -50%, 200% 50%, 150% 50%);\n  }\n  100% {\n    clip-path: polygon(-100% 50%, -50% 50%, 50% 150%, 0% 150%);\n  }\n}\n@keyframes clipb {\n  0% {\n    clip-path: polygon(40% -60%, 100% -50%, 190% 40%, 150% 50%);\n  }\n  100% {\n    clip-path: polygon(-100% 50%, -50% 50%, 50% 150%, 0% 150%);\n  }\n}\n@keyframes clip3 {\n  0% {\n    clip-path: polygon(-100% -150%, -50% -150%, -150% -50%, -200% -50%);\n  }\n  100% {\n    clip-path: polygon(150% 50%, 200% 50%, 100% 150%, 50% 150%);\n  }\n}\n@keyframes clip4 {\n  0% {\n    clip-path: polygon(150% -150%, 200% -150%, 300% -50%, 250% -50%);\n  }\n  100% {\n    clip-path: polygon(-100% 50%, -50% 50%, 50% 150%, 0% 150%);\n  }\n}\n\n@keyframes StretchFull {\n  0% {\n    height: 100vh;\n  }\n  100% {\n    height: 500px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
